import { render } from "./QRreader.vue?vue&type=template&id=9545f884"
import script from "./QRreader.vue?vue&type=script&lang=js"
export * from "./QRreader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__